module.exports = __webpack_public_path__ + "img/04503660003595.0545dbc7.png";